import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Main from 'comp/Main'
import Login from 'comp/Login'
import NF from 'comp/404'

Vue.use(Router)

const router = new Router({
  base: window.app.id === 'default' ? '/' : '/' + window.app.id + '/' ,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: "*",
      component: NF
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
